<template>
  <div :id="id" style="width: 100%">
    <div class="toolbar"></div>
    <Editor
      :class="['outline-class', showToolbar ? 'editorcontent' : '']"
      v-model="content"
      :init="editorInit"
    ></Editor>
  </div>
</template>

<script>
import axios from "axios";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/icons/default/icons.min.js"; // 引入富文本编辑器图标
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/hr";
import "tinymce/plugins/paste";
import "tinymce/plugins/autoresize";
import "@/assets/tinymce/plugins/indent2em";
import "@/assets/tinymce/plugins/lineheight";
import "@/assets/tinymce/plugins/formatpainter";

export default {
  name: "editTinymce",
  components: {
    Editor,
  },
  mounted() {
    window.nodesRecursion = this.nodesRecursion
    tinymce.init({});
  },
  props: {
    id: {
      // 编辑器id
      type: String,
      require: true,
    },
    value: {
      type: String,
      default: "",
    },
    showToolbar: {
      // 是否显示富文本工具栏
      type: Boolean,
      default: true,
    },
    placeholder: {
      // 编辑器占位符
      type: String,
      default: "",
    },
  },

  data() {
    return {
      content: this.value,
      editorInit: {
        // 富文本配置
        selector: `#${this.id}`,
        fixed_toolbar_container: `#${this.id} .toolbar`,
        language_url: "/admin/tinymce/zh_CN.js", // 中文语言包路径
        language: "zh_CN",
        skin_url: "/admin/tinymce/skins/ui/oxide", // 富文本css图标路径
        content_style: "body, button, input, select, textarea {font-family: 'Microsoft YaHei';font-size: 18px;} p {margin: 0;}",
        toolbar_mode: "sliding",
        statusbar: false, // 隐藏编辑器下方内容
        menubar: false, // 隐藏菜单栏
        placeholder: this.placeholder, // 占位内容
        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif", // 字体
        fontsize_formats: "11px 12px 14px 16px 18px 24px 36px 48px", // 字号
        plugins:
          "link lists image table wordcount media indent2em hr lineheight formatpainter autoresize paste", //  autoresize 富文本插件 paste
        min_height: 350,
        autoresize_on_init: true,
        toolbar: this.showToolbar
          ? "paste undo redo removeformat formatpainter fontsizeselect fontselect formatselect bold italic alignleft aligncenter alignright alignjustify | lineheight indent2em bullist numlist | link image media | hr blockquote italic strikethrough underline backcolor forecolor table"
          : false, // 工具栏 paste
        file_picker_callback: this.fileUplode, // 调用上传文件方法
        paste_postprocess: function(plugin, args) {
          args.node.childNodes.forEach(item => {
            if (item.innerHTML) {
              item.innerHTML = item.innerHTML.replace(/^\s*/g,"");
              item.style = 'text-indent: 2em;line-height: 2;font-size: 18px;'
            }
          });
          nodesRecursion(args.node.childNodes)
        },
        setup: function (editor) {
          // 设置富文本编辑框内容固定样式
          editor.on("init", function () {
            this.execCommand("fontName", false, "Microsoft YaHei");
            this.execCommand("fontSize", false, "18px");
            this.execCommand("lineHeight", false, "2");
          });
          // focus input wheel
          editor.on("focus input wheel  ", function (e) {
            var title = new URLSearchParams(location.search).get("title");
            // console.log(title);
            var sheight = title == "专著" ? 1114 : 200;

            if (!window.onscroll) {
              window.onscroll = function () {
                // console.log(window[1].scrollY, window.scrollY);

                if (window.scrollY > sheight || document.body > 1400) {
                  window.document.querySelector(
                    "#editor .tox-tinymce .tox-editor-header"
                  ).style = `
                        position: fixed !important;
                        top: 105px !important;
                        left: 0 !important;

                        background: rgb(236 235 235 / 96%);
                        width: 100% ;`;
                  document.querySelector(
                    "#editor .tox-toolbar-overlord"
                  ).style = `width:1200px;margin:0 auto;background: rgb(236 235 235 / 96%); padding:0 100px;`;
                  document.querySelector(
                    "#editor .tox-toolbar__primary"
                  ).style = "background:none !important;";
                  document.querySelector("#editor .tox-sidebar-wrap").style =
                    "margin-top:30px";
                } else if (window.scrollY <= sheight) {
                  document.querySelector("#editor .tox-editor-header").style = `
                        position: static;background:none;`;
                  document.querySelector(
                    "#editor .tox-toolbar-overlord"
                  ).style = `width:100%;margin:0 auto;background:#fff; `;
                  document.querySelector(
                    "#editor .tox-toolbar__primary"
                  ).style =
                    "background: url(data:image/svg+xml;charset=utf8,%3Csvg height='39px' viewBox='0 0 40 39px' width='40' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0' y='38px' width='100' height='1' fill='%23cccccc'/%3E%3C/svg%3E) left 0 top 0 #fff;";
                  document.querySelector(".tox-sidebar-wrap").style =
                    "margin-top:0px";
                }
              };
            }
          });
          editor.on("blur", function () {
            if (window[1]) {
              window[1].onscroll = null;
            }
            document.querySelector("#editor .tox-editor-header").style = `
                        position: static;background:none;`;
            document.querySelector(
              "#editor .tox-toolbar-overlord"
            ).style = `width:100%;margin:0 auto;background:#fff; `;
            document.querySelector("#editor .tox-toolbar__primary").style =
              "background: url(data:image/svg+xml;charset=utf8,%3Csvg height='39px' viewBox='0 0 40 39px' width='40' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0' y='38px' width='100' height='1' fill='%23cccccc'/%3E%3C/svg%3E) left 0 top 0 #fff;";
            document.querySelector("#editor .tox-sidebar-wrap").style =
              "margin-top:0px";
          });
        },
      },
    };
  },
  watch: {
    value(newVla) {
      this.content = newVla;
    },
    content(newVla) {
      this.$emit("input", newVla);
    },
  },
  methods: {
    // 循环遍历出复制到富文本的内容 选出img 和 a标签
    nodesRecursion(arr) {
      arr.forEach(item => {
        if (item.nodeName == "A") {
          var newNode = document.createElement('span'); // 创建一个元素
          newNode.textContent = item.textContent
          item.parentNode.replaceChild(newNode,item);//  获取子元素原来的父元素并将新父元素代替子元素
        } else if (item.nodeName == "IMG"){
          var parent = document.createElement('div'); //  新建一个父元素
          parent.style = 'text-align: center'; // 设置父元素样式
          item.parentNode.replaceChild(parent,item);//  获取子元素原来的父元素并将新父元素代替子元素
          parent.appendChild(item); // 将元素添加到新加的父元素里
        } else if(item.childNodes && item.childNodes.length > 0) {
          this.nodesRecursion(item.childNodes)
        } else {
          return
        }
      });
    },
    // 文件\视频上传
    fileUplode(callback, failure, meta) {
      let _that = this;
      var filetype =
        ".pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx";
      switch (
        meta.filetype // 当上传图片
      ) {
        case "image":
          filetype = ".jpg, .jpeg, .png, .gif";
          break;
        case "media": // 当上传视频
          filetype = ".mp3, .mp4";
          break;
        case "file": // 当上传文件
        default:
      }
      //模拟出一个input用于添加本地文件
      var input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", filetype);
      input.click();
      input.onchange = async function () {
        var file = this.files[0];
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        let param = new FormData();
        param.append("file", file);
        const { data } = await axios.post(_that.$global.url2, param, config);
        if (data.resultCode !== "200") {
          return;
        }
        callback(_that.$global.imgUrl + data.content.url, { text: file.name });
      };
    },

    // 富文本图片上传
    //   async imgUplode(blobInfo, succFun, failFun) {
    //     let config = {
    //       headers: { "Content-Type": "multipart/form-data" },
    //     };
    //     let param = new FormData();
    //     param.append("file", blobInfo.blob());
    //     const {data} = await axios.post(this.$global.url2, param, config);
    //     if (data.resultCode !== '200') {
    //         failFun('上传图片失败')
    //         return
    //     }
    //     succFun(this.$global.imgUrl+data.content.url)
    //   }
  },
};
</script>

<style lang="scss" scoped>
// .toolbar {
//   position: -webkit-sticky;
//   position: sticky;
//   overflow: hidden;
//   top: 106px;
//   z-index: 999;
//   // &::v-deep .tox-toolbar {
//   //   background-color: #f6f6f7;
//   // }
// }
.outline-class {
  outline-color: #d5e8fc;
}
.editorcontent {
  min-height: 200px;
  // max-height: 500px;
  overflow: auto;
}
::v-deep .tox-tinymce {
  border: 0;
}
.toolbarHeaderFixed {
  position: fixed;
  top: 105px;
  left: 0;
  background: rgb(236 235 235 / 96%);
  width: 100%;
  .toolbarOverlord {
    width: 1200px;
    margin: 0 auto;
    background: rgb(236 235 235 / 96%);
    padding: 0 100px;
  }
  .toolbarPrimary {
    background: none !important;
  }
}
</style>
